import {Node, NodeSpec} from 'prosemirror-model';

export const yuja_embed_spec: NodeSpec = {
  attrs: {
    src: {default: null},
    videoId: {default: null},
    nodeId: {default: null},
    accountId: {default: null},
  },
  group: 'block',
  draggable: true,
  parseDOM: [
    {
      tag: 'iframe.yuja-embed',
      getAttrs(dom) {
        const src = dom.getAttribute('src');
        // Extract video parameters from Yuja URL
        let videoId = null;
        let nodeId = null;
        let accountId = null;

        if (src) {
          const vMatch = src.match(/[?&]v=([^&]+)/);
          const nodeMatch = src.match(/[?&]node=([^&]+)/);
          const aMatch = src.match(/[?&]a=([^&]+)/);

          if (vMatch) videoId = vMatch[1];
          if (nodeMatch) nodeId = nodeMatch[1];
          if (aMatch) accountId = aMatch[1];
        }

        return {
          src,
          videoId,
          nodeId,
          accountId,
        };
      },
    },
  ],
  toDOM(node: Node) {
    // Construct the Yuja embed URL
    let yujaUrl = node.attrs.src;

    if (!yujaUrl && node.attrs.videoId) {
      yujaUrl = `https://uci.yuja.com/V/Video?v=${node.attrs.videoId}`;

      if (node.attrs.nodeId) {
        yujaUrl += `&node=${node.attrs.nodeId}`;
      }

      if (node.attrs.accountId) {
        yujaUrl += `&a=${node.attrs.accountId}`;
      }
    }

    return [
      'div',
      {
        class: 'yuja-embed-wrapper',
      },
      [
        'iframe',
        {
          class: 'yuja-embed',
          src: yujaUrl,
          width: '100%',
          height: '480px',
          frameborder: '0',
          allowfullscreen: 'true',
          allow:
            'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
        },
      ],
    ];
  },
};
